export const isEmpty = (value) => {
    return (
        value == null ||
        (typeof value === 'string' && (value.trim() === '' || value.trim() === 'undefined'))
    )
}
